import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="admin--companies-form"
export default class extends Controller {
  static targets = ["form", "databaseName", "submit", "userSection"]

  connect() {
    this.resetForm()
  }

  edit(event) {
    const row = event.currentTarget
    const id = row.dataset.id

    fetch(`/admin/companies/${id}.json`)
      .then(r => r.json())
      .then(data => {
        this.databaseNameTarget.value = data.database_name
        this.databaseNameTarget.disabled = true
        this.formTarget.action = `/admin/companies/${id}`
        this._setMethod("patch")
        
        this.submitTarget.value = "Update Company"
        this.hideUserSection()
      })
  }

  afterSubmit(event) {
    if (!event.detail.success) return

    this.resetForm()
  }

  resetForm() {
    this.formTarget.reset()
    this.databaseNameTarget.disabled = false
    this.formTarget.action = "/admin/companies"
    this._setMethod("post")
    this.submitTarget.value = "Create Company"
    this.showUserSection()
  }

  hideUserSection() {
    this.userSectionTarget.classList.add("d-none")
  }

  showUserSection() {
    this.userSectionTarget.classList.remove("d-none")
  }

  _setMethod(method) {
    let input = this.formTarget.querySelector("input[name='_method']")

    if (!input && method !== "post") {
      input = document.createElement("input")
      input.type = "hidden"
      input.name = "_method"
      this.formTarget.appendChild(input)
    }

    if (input) {
      if (method === "post") {
        input.remove()
      } else {
        input.value = method
      }
    }
  }
}
